import { render, staticRenderFns } from "./TextAreaOnly.vue?vue&type=template&id=dd5eb43a"
import script from "./TextAreaOnly.vue?vue&type=script&lang=js"
export * from "./TextAreaOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports